import { FC, ReactNode } from 'react';
import AllieMainLayoutMobile from './MainLayout.mobile';
import { AllieMainLayoutDesktop } from './MainLayout.desktop';
import { AllieTab } from '../../../components';
import { isMobile } from '../../../common/utils';

export interface AllieMainLayoutProps {
  menu: React.FC | null;
  page: React.FC;
  tabs?: AllieTab[];
  tabSelected: string;
}

export const AllieMainLayout: FC<AllieMainLayoutProps> = (props) => {
  const MainLayoutByPlatform = isMobile ? AllieMainLayoutMobile : AllieMainLayoutDesktop;

  return <MainLayoutByPlatform {...props} />;
};
